export default "__VITE_ASSET__a3a859e8__"